<template>
    <views class="full-screen-ad">
        <views class="close" @click="close">{{ tipTitle }}</views>
        <images :src="data.url" @click="handleTarget(data.target_url)"></images>
    </views>
</template>

<script>
import tools from '@/mixins/tools'
export default {
    mixins: [tools],
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        value: Boolean
    },
    data() {
        return {
            title: '跳过',
            time: 0,
            timer: null
        }
    },
    computed: {
        tipTitle() {
            return `${this.title}${this.time}`
        }
    },
    watch: {
        time(n, o) {
            if (n === 0) {
                this.close()
            }
        }
    },
    created() {
        this.time = this.data.seconds
    },
    mounted() {
        this.setTime()

        // 禁止滚动
        document.body.addEventListener('touchmove', this.handler, { passive: false })
        document.body.addEventListener('wheel', this.handler, { passive: false })
    },
    destroyed() {
        // 移除禁止滚动
        document.body.removeEventListener('touchmove', this.handler, { passive: false })
        document.body.removeEventListener('wheel', this.handler, { passive: false })
    },
    methods: {
        handler() {
            event.preventDefault()
            event.stopPropagation()
        },
        setTime() {
            clearInterval(this.timer)
            this.timer = setInterval(() => {
                this.time--
            }, 1000)
        },
        close() {
            clearInterval(this.timer)
            this.$emit('input', false)
        },
        handleTarget(url) {
            if (url) {
                this.push(url)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
